export const GET_CUSTOM_TABLE = 'GET_CUSTOM_TABLE';
export const SET_CUSTOM_TABLE = 'SET_CUSTOM_TABLE';
export const GET_CUSTOM_TABLE_LIVE = 'SET_CUSTOM_TABLE_LIVE';